import { createApp } from 'vue'
import { createPinia } from 'pinia'
import 'ant-design-vue/dist/reset.css'
import '@/styles/global.css'
import '@/styles/details.css'
import '@/styles/products.css'
import '@/styles/admin-pages.css'
import App from './App.vue'
import router from './router'

const app = createApp(App).use(createPinia()).use(router)

app.mount('#app')
